import { useMemo } from 'react'
import { isNil } from 'lodash'
import useSandreList from './useSandreList'
import { SANDRE } from '../../referencial/constants/ReferencialConstants'
import { getMeasureTempRef, getMeasuresTempRef, getOffsetFromTempRef } from '../TempRefUtil'

// Décalage (GMT+X) dans lequel restituer les mesures d'une station, d'après ses références
// temporelles. undefined => aucune référence exploitable, on retombe sur le fuseau du navigateur.
// tempRef : code SANDRE choisi dans le sélecteur du graphique, qui prime sur la référence station.
const useMeasureTempRef = (tempRefs = [], dataType, tempRef) => {
    const refTempList = useSandreList(SANDRE.REF_TEMPORELLES)

    return useMemo(
        () => isNil(tempRef) ? getMeasureTempRef(tempRefs, dataType, refTempList) : getOffsetFromTempRef(tempRef, refTempList),
        [tempRefs, dataType, refTempList, tempRef],
    )
}

// Variante pour un graphique affichant plusieurs types de données sur un axe X commun.
const useMeasuresTempRef = (tempRefs = [], dataTypes = [], tempRef) => {
    const refTempList = useSandreList(SANDRE.REF_TEMPORELLES)

    return useMemo(
        () => isNil(tempRef) ? getMeasuresTempRef(tempRefs, dataTypes, refTempList) : getOffsetFromTempRef(tempRef, refTempList),
        [tempRefs, dataTypes, refTempList, tempRef],
    )
}

export default useMeasureTempRef
export { useMeasuresTempRef }